import { useEffect, useState } from 'react';
import { checkOrder, type Checks } from '../api/trading';
import type { CheckRequest } from '../api/generated/types.gen';

const REFRESH_MS = 3000;

/**
 * The guardrail verdicts for the order the ticket currently describes (plan 010). Like the cost estimate, it
 * follows every input change on its own and refreshes every few seconds as the account moves; it never gates
 * anything itself.
 */
export function useGuardrails(req: CheckRequest | null) {
  const [checks, setChecks] = useState<Checks | null>(null);
  const [error, setError] = useState('');
  const key = req ? JSON.stringify(req) : null;
  useEffect(() => {
    setChecks(null); setError('');
    if (!req) return;
    let dead = false; const ctrl = new AbortController();
    const load = async () => {
      try { const r = await checkOrder(req, ctrl.signal); if (!dead) { setChecks(r); setError(''); } }
      catch (e) { if (!dead && !(e instanceof DOMException && e.name === 'AbortError')) setError(e instanceof Error ? e.message : 'Guardrails unavailable'); }
    };
    const first = setTimeout(load, 200);
    const timer = setInterval(load, REFRESH_MS);
    return () => { dead = true; ctrl.abort(); clearTimeout(first); clearInterval(timer); };
  }, [key]);
  return { checks, error };
}
